import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import PageViewTracker from "@/components/PageViewTracker";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import BuyPage from "@/pages/BuyPage";
import CardRequestPage from "@/pages/CardRequestPage";
import ShowsPage from "@/pages/ShowsPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderStatusPage from "@/pages/OrderStatusPage";
import ShippingPage from "@/pages/ShippingPage";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import SigninPage from "@/pages/SigninPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import AccountPage from "@/pages/AccountPage";
import TradePage from "@/pages/TradePage";
import AdminPage from "@/pages/AdminPage";
import { Toaster } from "sonner";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <PageViewTracker />
          <div className="min-h-screen text-white flex flex-col relative">
            <div className="site-bg" aria-hidden="true" />
            <div className="relative z-10 flex flex-col flex-1">
              <NavBar />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/shop" element={<ShopPage />} />
                  <Route path="/buy" element={<BuyPage />} />
                  <Route path="/request-cards" element={<CardRequestPage />} />
                  <Route path="/shows" element={<ShowsPage />} />
                  <Route path="/checkout" element={<CheckoutPage />} />
                  <Route path="/order" element={<Navigate to="/checkout" replace />} />
                  <Route path="/pulls" element={<Navigate to="/shop" replace />} />
                  <Route path="/order-status/:orderId" element={<OrderStatusPage />} />
                  <Route path="/shipping" element={<ShippingPage />} />
                  <Route path="/vault" element={<Navigate to="/shop" replace />} />
                  <Route path="/trade" element={<TradePage />} />
                  <Route path="/signup" element={<SignupPage />} />
                  <Route path="/signin" element={<SigninPage />} />
                  <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                  <Route path="/reset-password" element={<ResetPasswordPage />} />
                  <Route path="/account" element={<AccountPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/admin" element={<AdminPage />} />
                  <Route path="*" element={<HomePage />} />
                </Routes>
              </main>
              <Footer />
            </div>
            <Toaster theme="dark" position="top-right" />
          </div>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
